import React from 'react';

import { makeStyles } from '@mui/styles';
import { jbColors } from 'theme/jbColors';
import { Skeleton, SkeletonProps } from '@mui/material';

const useStyles = makeStyles({
  root: {
    '&.MuiSkeleton-root': {
      backgroundColor: jbColors.app.lightGrey,
    },
  },
});

const LoadingSkeleton = (props: SkeletonProps) => {
  const classes = useStyles();

  return <Skeleton variant="text" width={200} className={classes.root} {...props} />;
};

export default LoadingSkeleton;
